module.exports = __webpack_public_path__ + "static/media/speaker_512.83512001.png";